import { useCallback, useState } from "react";
import { useSnackbar } from "~/Provider";
import { fetchOrderQuota } from "~/api/endpoints";
import { ActionType } from "~/pages/constants";
import { PairedToken, TradeToken } from "~/types";

const useFetchTradePrice = () => {
    const snackbar = useSnackbar();
    const [isFetching, setIsFetching] = useState(false);
    const [fetchedRouter, setFetchedRouter] = useState<any | null>(null);

    const fetchPrice = useCallback(
        async (
            tradeActionType: ActionType,
            tradeToken: TradeToken,
            pairedToken: PairedToken,
            isTopAmount: boolean,
            topAmount: string,
            bottomAmount: string,
            slippage: number
        ) => {
            if (isFetching) return;
            if (isTopAmount && parseFloat(topAmount) <= 0) return;
            if (!isTopAmount && parseFloat(bottomAmount) <= 0) return;

            if (!tradeToken?.token_base?.contract) return;
            if (!pairedToken?.token_base?.contract) return;

            const params =
                tradeActionType === ActionType.Buy
                    ? {
                          from_chain_id: Number(
                              pairedToken.token_base.chain_id
                          ),
                          from_contract: pairedToken.token_base.contract,
                          from_amount: isTopAmount ? "0" : bottomAmount,
                          to_chain_id: Number(tradeToken.token_base.chain_id),
                          to_contract: tradeToken.token_base.contract,
                          to_amount: isTopAmount ? topAmount : "0",
                          slippage: slippage,
                      }
                    : {
                          from_chain_id: Number(tradeToken.token_base.chain_id),
                          from_contract: tradeToken.token_base.contract,
                          from_amount: isTopAmount ? topAmount : "0",
                          to_chain_id: Number(pairedToken.token_base.chain_id),
                          to_contract: pairedToken.token_base.contract,
                          to_amount: isTopAmount ? "0" : bottomAmount,
                          slippage: slippage,
                      };

            try {
                setIsFetching(true);
                const orderQuota = await fetchOrderQuota(params);
                setIsFetching(false);
                const router = orderQuota.data.routers[0];
                setFetchedRouter(router); // 存储当前路由

                return orderQuota.data; // 返回请求结果
            } catch (err: any) {
                setIsFetching(false);
                if ("message" in err) {
                    snackbar.error(err.message);
                }
            }
        },
        []
    );

    return { isFetching, fetchPrice, fetchedRouter, setFetchedRouter };
};

export default useFetchTradePrice;
